// extracted by mini-css-extract-plugin
module.exports = {"base":"Quote-module-base","avatar":"Quote-module-avatar","avatarNoCite":"Quote-module-avatar-no-cite","cite":"Quote-module-cite","quote":"Quote-module-quote"};